import React from "react";
import { Asset, PreviewAsset } from "src/types/assets";
import { Assessment, Lesson, PodcastLesson, SimulationAttempt, SimulationLesson, SimulationSession } from "src/types/coaching/courses";
import { CourseContentSession } from "src/types/coaching/learners";
import { Podcast } from "src/types/coaching/podcast";
import { Simulation } from "src/types/coaching/simulation";

export interface SimulationReportState {
  attempt: SimulationAttempt;
  session: SimulationSession;
  content?: any;
}

export interface CourseContextProps {
  id?: string;
  courseContent?: Lesson | Assessment | PodcastLesson | Simulation | Podcast | null;
  courseContentSession?: CourseContentSession;

  activeAssessment?: Assessment | null;
  
  asset?: {
    loading: boolean;
    item: Asset | null;
    preview: PreviewAsset | null;
  }

  startingCourse?: boolean;
  enrollingCourse?: boolean;
  endingCourse?: boolean;
  retakingCourse?: boolean;

  completingCourse?: boolean;
  completedCourse?: boolean;
  canCompleteCourse?: boolean;

  startCourse?: () => void;
  enrollCourse?: () => void;
  resumeCourse?: () => void;
  endCourse?: () => void;
  retakeCourse?: () => void;

  getContentSessions?: () => CourseContentSession[];

  // eslint-disable-next-line no-unused-vars
  onBack?: () => void;

  // eslint-disable-next-line no-unused-vars
  onContentClicked?: (index: number, section?: number | null) => void;
  
  // eslint-disable-next-line no-unused-vars
  createCourseContentSession?: (courseContent: Lesson | Assessment | PodcastLesson | SimulationLesson) => void;

  // eslint-disable-next-line no-unused-vars
  fetchCourseContentSession?: (courseContent: Lesson | Assessment | PodcastLesson | SimulationLesson, session: string) => void;

  // eslint-disable-next-line no-unused-vars
  updateCourseContentSession?: (courseContent: Lesson | Assessment | PodcastLesson | SimulationLesson, session: string, duration: number, progress: number) => void;

  // eslint-disable-next-line no-unused-vars
  completeCourseContentSession?: (courseContent: Lesson | Assessment | PodcastLesson | SimulationLesson, session: string, duration: number, progress: number) => void;

  // eslint-disable-next-line no-unused-vars
  fetchAssessmentReport?: (courseContent: Assessment, session: string) => void;

  // eslint-disable-next-line no-unused-vars
  startAssessment?: (assessment: Assessment) => void;

  // eslint-disable-next-line no-unused-vars
  endAssessment?: (assessment: Assessment) => void;

  // eslint-disable-next-line no-unused-vars
  recordAnswerForQuestion?: (assessment: Assessment, question: string, answer: string) => void;

  // eslint-disable-next-line no-unused-vars
  recordQuestionSession?: (assessment: Assessment, question: string, answer: string, duration: number) => void;

  // Lesson
  // eslint-disable-next-line no-unused-vars
  createLessonAnalyticsEvent?: (lesson: Lesson) => void;

  // eslint-disable-next-line no-unused-vars
  recordLessonAnalyticsEvent?: (lesson: Lesson, session: string, request: any) => void;

  // eslint-disable-next-line no-unused-vars
  fetchLesson?: (lesson: Lesson) => void;

  // eslint-disable-next-line no-unused-vars
  fetchLessonPreview?: (lesson: Lesson) => void;

  simulation?: any;
  isSidebarCollapsed?: boolean;
  // eslint-disable-next-line no-unused-vars
  setIsSidebarCollapsed?: (value: boolean) => void;
  activeTab?: number;
  // eslint-disable-next-line no-unused-vars
  setActiveTab?: (value:number) => void;
  secondaryView?: null | "call-recording" | "call-recording-minimized";
  changeSecondaryView?: (view: null | "call-recording" | "call-recording-minimized") => void;
}

export const CourseContext = React.createContext<CourseContextProps>({});
